import axios from "axios";
import { getEnvVariable } from "helpers/commonFunctions";

// Create a new Axios instance
const host = getEnvVariable("REACT_APP_API_URL");
const apiClient = axios.create({
  baseURL: `${host}`,
  headers: {
    "Content-Type": "application/json",
  },
});

const currentLang = localStorage.getItem("LANG") || "vi";
apiClient.interceptors.request.use(
  (config) => {
    let customConfig = { ...config };
    customConfig.headers = {
      ...customConfig.headers,
      "Accept-Language": currentLang,
    };
    return customConfig;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
    }
    return Promise.reject(error);
  }
);
export default apiClient;
